export default __webpack_public_path__ + "static/media/Physicians Mutual.269dc19e.png";